/**
 * Helper functions to determine user tier information
 * In a real app, this would come from the API/database
 */

// Dummy mapping: some users are Insider (pro tier)
// In production, this would be fetched from the database
const insiderUsers = new Set<string>([
  "kringloopfan", // User u1
  "vintagelover", // User u2
  "demo_gebruiker", // Demo user
]);

/**
 * Check if a username is an Insider (pro tier)
 */
export function isInsider(username: string | null | undefined): boolean {
  if (!username) return false;
  return insiderUsers.has(username);
}

/**
 * Get the tier for a username
 */
export function getUserTier(username: string | null | undefined): "pro" | "free" | "anonymous" {
  if (!username) return "anonymous";
  return isInsider(username) ? "pro" : "free";
}